module.exports = __webpack_public_path__ + "img/resources.61da3172.png";